import { getAllPaidHubsInProductInventory, getBundledProductOwnershipLevel, getCrmSuiteOwnershipLevel, getCurrentOwnedPaidCoreSeatsTotal, getCurrentTermTotalDiscountsForOwnedSkuId, getDaysSinceProductStartDateFromProductInventory, getHasPaidHubInProductInventory, getHasProductInProductInventory, getHasProductVersionInProductInventory, getHasProductVersionOrHigherProductLevelInProductInventory, getHasProductsInProductInventory, getHasSkuInProductInventory, getHighestProductLevelFromProductInventory, getIsSkuUpgraded, getOwnedBundleProductContainingHub, getProductVersionFromProductInventory, getProductVersionsFromProductInventory, getProductsFromProductInventory, getProductsFromProductInventoryQuantity, getProductsFromProductInventoryQuantityPackQuantity, getQuantityPackProductConfigurationsFromProductInventory, hasPlanBuilderProductsInBundledProductInventory, hasProductLineInBundledProductInventory, hasProductVersionInBundledProductInventory } from 'pricing-pages-lib/utils/productInventoryUtils';
import { getMaxProductVersionQuantity } from 'pricing-pages-lib/utils/productsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { orderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { FetchProductInventoryRequestTypes } from '../actions/ProductInventoryActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { transformState } from './SelectorUtils';
export const crmSuiteOwnershipLevel = createSelectorFromUtil(getCrmSuiteOwnershipLevel, transformState);
export const ownsCrmSuiteProductLevel = (state, {
  productLevel
}) => {
  return productLevel && crmSuiteOwnershipLevel(state) === productLevel;
};
export const fetchProductInventoryStatus = makeRequestStatusSelector(FetchProductInventoryRequestTypes.REQUEST);
export const productsFromProductInventorySelector = createSelectorFromUtil(getProductsFromProductInventory, transformState);
export const hasProductInProductInventorySelector = createSelectorFromUtil(getHasProductInProductInventory, transformState);
export const hasSkuInProductInventorySelector = createSelectorFromUtil(getHasSkuInProductInventory, transformState);

// Can be used to get the highest level for either a specific hub or all hubs
export const highestProductLevelFromProductInventorySelector = createSelectorFromUtil(getHighestProductLevelFromProductInventory, transformState);
export const hasHigherProductLevelInProductInventorySelector = (state, {
  productLine,
  productLevel
}) => {
  const highestProductLevelFromProductInventoryLevel = highestProductLevelFromProductInventorySelector(state, {
    productLine
  });
  return orderedProductLevels.indexOf(highestProductLevelFromProductInventoryLevel) > orderedProductLevels.indexOf(productLevel);
};
export const hasProductLevelOrHigherInProductInventorySelector = (state, {
  productLine,
  productLevel
}) => {
  const highestProductLevelFromProductInventoryLevel = highestProductLevelFromProductInventorySelector(state, {
    productLine
  });
  return orderedProductLevels.indexOf(highestProductLevelFromProductInventoryLevel) >= orderedProductLevels.indexOf(productLevel);
};
export const hasProductLineSelectorInProductInventorySelector = (state, {
  productLine
} = {}) => {
  const productsFromProductInventory = productsFromProductInventorySelector(state);
  if (!productsFromProductInventory || !productLine) return false;
  return productsFromProductInventory.some(product => product && product.productLine === productLine && product.productLevel);
};
export const hasProductVersionOrHigherProductLevelInProductInventorySelector = createSelectorFromUtil(getHasProductVersionOrHigherProductLevelInProductInventory, transformState);
export const allPaidHubsInProductInventorySelector = createSelectorFromUtil(getAllPaidHubsInProductInventory, transformState);
export const hasPaidHubInProductInventorySelector = createSelectorFromUtil(getHasPaidHubInProductInventory, transformState);
export const hasProductVersionInProductInventorySelector = createSelectorFromUtil(getHasProductVersionInProductInventory, transformState);
export const hasProductVersionInBundledProductInventorySelector = createSelectorFromUtil(hasProductVersionInBundledProductInventory, transformState);
export const hasProductLineInBundledProductInventorySelector = createSelectorFromUtil(hasProductLineInBundledProductInventory, transformState);
export const hasPlanBuilderProductsInBundledProductInventorySelector = createSelectorFromUtil(hasPlanBuilderProductsInBundledProductInventory, transformState);

// Selects a single productVersion based on productAttributeFilters supplied
export const productVersionFromProductInventorySelector = createSelectorFromUtil(getProductVersionFromProductInventory, transformState);

// Returns productVersionsFromProductInventory, optionally filtered based on
// attributes from the product a version belongs to
export const productVersionsFromProductInventorySelector = createSelectorFromUtil(getProductVersionsFromProductInventory, transformState);
export const productsFromProductInventoryQuantityPackQuantitySelector = createSelectorFromUtil(getProductsFromProductInventoryQuantityPackQuantity, transformState);
export const productsFromProductInventoryQuantitySelector = createSelectorFromUtil(getProductsFromProductInventoryQuantity, transformState);
export const hasMaxProductQuantityInProductInventorySelector = (state, {
  skuId
}) => {
  const productsFromProductInventoryQuantity = productsFromProductInventoryQuantitySelector(state, {
    skuId
  });
  return productsFromProductInventoryQuantity >= getMaxProductVersionQuantity(transformState(state), {
    skuId
  });
};
export const hasProductVersionOrNewerInProductInventorySelector = (state, {
  apiName,
  versionNumber
}) => {
  return hasProductVersionInProductInventorySelector(state, {
    apiName,
    versionNumber,
    versionNumberComparison: (ownedVersion, targetVersion) => ownedVersion >= targetVersion
  });
};
export const quantityPackProductConfigurationsFromProductInventorySelector = createSelectorFromUtil(getQuantityPackProductConfigurationsFromProductInventory, transformState);
export const daysSinceProductStartDateFromProductInventorySelector = createSelectorFromUtil(getDaysSinceProductStartDateFromProductInventory, transformState);
export const isSkuUpgradedSelector = createSelectorFromUtil(getIsSkuUpgraded, transformState);
export const currentTermTotalDiscountsForOwnedSkuIdSelector = createSelectorFromUtil(getCurrentTermTotalDiscountsForOwnedSkuId, transformState);
export const currentOwnedPaidCoreSeatsTotalSelector = createSelectorFromUtil(getCurrentOwnedPaidCoreSeatsTotal, transformState);
export const hasProductsInProductInventorySelector = createSelectorFromUtil(getHasProductsInProductInventory, transformState);
export const bundledProductOwnershipLevelSelector = createSelectorFromUtil(getBundledProductOwnershipLevel, transformState);
export const ownedBundleProductContainingHubSelector = createSelectorFromUtil(getOwnedBundleProductContainingHub, transformState);